export const hasPhysicalDimensions = dimensions => {
  if (!dimensions || typeof dimensions !== "object") {
    return false;
  }

  const hasLabel = typeof dimensions.label === "string" && dimensions.label.trim().length > 0;
  const numericValues = [dimensions.width, dimensions.height, dimensions.depth];
  const hasNumericDimension = numericValues.some(value => typeof value === "number" && Number.isFinite(value));

  return hasLabel || hasNumericDimension;
};

export const shouldDisableScalingForData = data => {
  if (!data || typeof data !== "object") {
    return false;
  }

  if (data.assetCategory !== "digital-twin-art") {
    return false;
  }

  return hasPhysicalDimensions(data.assetDimensions);
};

const getScaleLockDataFromNode = node => {
  if (!node) {
    return null;
  }

  if (typeof node.getScaleLockData === "function") {
    return node.getScaleLockData();
  }

  const { assetCategory, assetDimensions } = node;

  if (assetCategory === undefined && assetDimensions === undefined) {
    return null;
  }

  return { assetCategory, assetDimensions };
};

export const shouldDisableScalingForNode = (node, dataExtractor = getScaleLockDataFromNode) => {
  if (!node) {
    return false;
  }

  if (node.disableScaling) {
    return true;
  }

  const data = dataExtractor(node);
  return shouldDisableScalingForData(data);
};

export const selectionHasScalingLock = (nodes, dataExtractor = getScaleLockDataFromNode) => {
  if (!Array.isArray(nodes) || nodes.length === 0) {
    return false;
  }

  return nodes.some(node => shouldDisableScalingForNode(node, dataExtractor));
};

export const extractScaleLockData = getScaleLockDataFromNode;
